import storePersist from '../storePersist';
import * as actionTypes from './types';

const INITIAL_KEY_STATE: any = {
    subscription: null,
    accountTypes: null,
    guestApplication: null,
    b2cApplication: null,
    isb2cAuthenticated: false,
    b2bApplication: null,
    isb2bAuthenticated: false,
    scpApplication: null,
    isSCPAuthenticated: false,
    serviceApplication: null,
    isServiceAuthenticated: false,
    managementApplication: null,
    isManagementAuthenticated: false,

    current: null,
    isLoading: false,
    isSuccess: false,
};

const INITIAL_STATE: any = {
    current: {
        subscription: null,
        accountTypes: null,
        guestApplication: null,
        b2cApplication: null,
        isb2cAuthenticated: false,
        b2bApplication: null,
        isb2bAuthenticated: false,
        scpApplication: null,
        isSCPAuthenticated: false,
        serviceApplication: null,
        isServiceAuthenticated: false,
        managementApplication: null,
        isManagementAuthenticated: false,
    },
    list: {
        result: {
            items: [{ 
                subscription: null,
                accountTypes: null,
                guestApplication: null,
                b2cApplication: null,
                isb2cAuthenticated: false,
                b2bApplication: null,
                isb2bAuthenticated: false,
                scpApplication: null,
                isSCPAuthenticated: false,
                serviceApplication: null,
                isServiceAuthenticated: false,
                managementApplication: null,
                isManagementAuthenticated: false,
            }],
            pagination: {
                current: 1,
                pageSize: 5,
                total: 1,
                showSizeChanger: false,
            },
        },
        isLoading: false,
        isSuccess: false,
    },
    create: INITIAL_KEY_STATE,
    update: INITIAL_KEY_STATE,
    delete: INITIAL_KEY_STATE,
    read: INITIAL_KEY_STATE,
    search: { ...INITIAL_KEY_STATE, result: [] },
};

const routerReducer = (state = INITIAL_STATE, action: any) => {
    const { payload, keyState } = action;
    switch (action.type) {
        case actionTypes.SET_SUBSCRIPTION:
            return {
                ...state,                
                ...payload
            };
        case actionTypes.SET_ACCOUNT_TYPES:
            return {
                ...state,                
                ...payload
            }; 
        case actionTypes.SET_GUEST_APPLICATION:
            return {
                ...state,                
                ...payload
            }; 
        case actionTypes.SET_B2C_APPLICATION:
            return {
                ...state,                
                ...payload
            };        
        case actionTypes.SET_B2B_APPLICATION:
            return {
                ...state,                
                ...payload
            };                            
        case actionTypes.SET_SCP_APPLICATION:
            return {
                ...state,                
                ...payload
            };        
        case actionTypes.SET_SERVICE_APPLICATION:
            return {
                ...state,                
                ...payload
            };       
        case actionTypes.SET_MANAGEMENT_APPLICATION:
            return {
                ...state,                
                ...payload
            };                        
        case actionTypes.SET_IS_B2C_AUTHENTICATED:
            return {
                ...state,                
                ...payload
            }; 
        case actionTypes.SET_IS_B2B_AUTHENTICATED:
            return {
                ...state,                
                ...payload
            };   
        case actionTypes.SET_IS_SCP_AUTHENTICATED:
            return {
                ...state,                
                ...payload
            };           
        case actionTypes.SET_IS_SERVICE_AUTHENTICATED:
            return {
                ...state,                
                ...payload
            };  
        case actionTypes.SET_IS_MANAGEMENT_AUTHENTICATED:
            return {
                ...state,                
                ...payload
            };                                             
        case actionTypes.ROUTER_RESET_STATE:
            return INITIAL_STATE;
        case actionTypes.ROUTER_CURRENT_ITEM:
            return {
                ...state,
                current: {
                    ...state,
                    result: payload,
                },
            };
        case actionTypes.ROUTER_REQUEST_LOADING:
            return {
                ...state,
                [keyState]: {
                    ...state[keyState],
                    isLoading: true,
                },
            };
        case actionTypes.ROUTER_REQUEST_FAILED:
            return {
                ...state,
                [keyState]: {
                    ...state[keyState],
                    isLoading: false,
                    isSuccess: false,
                },
            };
        case actionTypes.ROUTER_REQUEST_SUCCESS:

            return {
                ...state,
                [keyState]: {
                    result: payload,
                    isLoading: false,
                    isSuccess: true,
                },
            };
        case actionTypes.ROUTER_CURRENT_ACTION:
            return {
                ...state,
                [keyState]: {
                    ...INITIAL_KEY_STATE,
                    current: payload,
                },
            };
        case actionTypes.ROUTER_RESET_ACTION:
            return {
                ...state,
                [keyState]: {
                    ...INITIAL_STATE[keyState],
                },
            };
        default:
            return state;
    }
};

export default routerReducer;